export default __webpack_public_path__ + "static/media/Trewkat.ab881096.jpg";